import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ShiftDayParams, ShiftService } from '@app/services/shift.service';

@Component({
  selector: 'tt-shift-day',
  templateUrl: './shift-day.component.html',
  styleUrls: ['./shift-day.component.css'],
  standalone: false,
})
export class ShiftDayComponent implements OnInit {
    public params: ShiftDayParams = { shift_id: '', dayno: '' };
    public dayName = '';
    public timeUsed = '';
    public selectedTab = 'workhours';
    public hours: Item[] = [];
    public breaks: Item[] = [];
    public readonly tabletSize: MediaQueryList;

    constructor(
        private readonly shift: ShiftService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.tabletSize = layout.getMediaQueries().tablet;
    }

    public async ngOnInit(): Promise<void> {
        this.params = { shift_id: String(this.navigator?.params['shift_id'] ?? ''), dayno: String(this.navigator?.params['dayno'] ?? '') };
        const [weekDays, hours, breaks] = await Promise.all([this.shift.getWeekDays({ shift_id: this.params.shift_id }), this.shift.getDayTimes(this.params), this.shift.getDayBreaks(this.params)]);
        const day = weekDays.find(day => String(day.item_id) === this.params.dayno);
        this.dayName = day?.item_name ?? '';
        this.timeUsed = day?.item_timeused.replace('.000', '') ?? '';
        this.hours = hours;
        this.breaks = breaks;
    }

    public async selectTab(value: string): Promise<void> {
        this.selectedTab = value;
        if (value === 'workhours') this.hours = await this.shift.getDayTimes(this.params);
        else this.breaks = await this.shift.getDayBreaks(this.params);
    }
}
